export default "__VITE_ASSET__0abde0db__"